import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { API_BASE_URL } from './config';
import './i18n';
import './index.css';
import { IS_MESSENGER } from './config/appVariant';
import App from './App';
import MessengerApp from './MessengerApp';

// Set axios baseURL (config.js already handles fallback to window.location.origin)
if (API_BASE_URL) {
  axios.defaults.baseURL = API_BASE_URL;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {IS_MESSENGER ? <MessengerApp /> : <App />}
  </React.StrictMode>
);
